import { Offer } from '../SharedMenuEditorPage/types';

export const getAllOfferImages = (offers: Offer[]) => [
  ...offers.flatMap(offer => {
    if (offer.images && offer.images.length > 0) {
      return offer.images.map(image => image.url);
    }
    return [];
  }),
];
